import { gql } from "urql";
export const projectFields = gql`
  fragment ProjectFields on Project {
    title
    slug
    location
    size
    year
    site
    order
    projectType
    quoteOnProject
    ImageSlider {
      description
      title
      image {
        data {
          attributes {
            url
            name
            alternativeText
            caption
          }
        }
      }
    }
    ImageBlocks {
      images(pagination: { limit: 100 }) {
        data {
          attributes {
            url
            alternativeText
            caption
            name
            width
            height
          }
        }
      }
    }
    Blueprints {
      images {
        data {
          attributes {
            url
            alternativeText
            name
          }
        }
      }
    }
    Testimonial {
      name
      designation
      description
      image {
        data {
          attributes {
            url
            name
            alternativeText
          }
        }
      }
    }

    thumbnail {
      data {
        attributes {
          url
          alternativeText
          name
          formats
        }
      }
    }
    banner {
      data {
        attributes {
          url
          alternativeText
          name
          formats
        }
      }
    }
    mobileBanner {
      data {
        attributes {
          url
          alternativeText
          name
          formats
        }
      }
    }
    gallery {
      data {
        attributes {
          url
          alternativeText
          name
          formats
        }
      }
    }
    project_tags {
      data {
        attributes {
          name
        }
      }
    }
    shortTitle
    shortDescription
    seo {
      metaTitle
      metaDescription
    }
  }
`;
export const QUERY_PROJECT_TAGS = gql`
  query getProjectTags($start: Int!, $limit: Int!, $sortBy: [String]) {
    projectTags(pagination: { start: $start, limit: $limit }, sort: $sortBy) {
      data {
        attributes {
          name
          projects(pagination: { limit: 100 }) {
            data {
              id
            }
          }
        }
      }
    }
  }
`;

export const QUERY_PROJECTS = gql`
  ${projectFields}
  query getProjectsByTag(
    $limit: Int!
    $start: Int!
    $filter: ProjectFiltersInput
    $sortBy: [String]
  ) {
    projects(
      pagination: { start: $start, limit: $limit }
      filters: $filter
      sort: $sortBy
    ) {
      data {
        id
        attributes {
          ...ProjectFields
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;
